import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import SVG2_1 from '@/components/UI/svg/PowerOcean/App/SVG2_1';
import SVG2_2 from '@/components/UI/svg/PowerOcean/App/SVG2_2';
import SVG2_3 from '@/components/UI/svg/PowerOcean/App/SVG2_3';

export default function B() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('poweroceanapp');
    const { locale } = useRouter();

    return (
        <div className={`ef-app-pc-b ${css.efAppPCB}`}>
            <div className="text-wrapper">
                <p className="sub-title">{t('sec2_subtitle')}</p>
                <p className="title">{t('sec2_title')}</p>
                <p className="desc">{t('sec2_desc')}</p>
            </div>
            <div className="panel">
                <div className="left">
                    <SVG2_1 />
                    <p className="title yellow">{t('sec2_panel1')}</p>
                    <ul>
                        {t.rich('sec2_panel1_list', {
                            li1: (text: any) => <li>{text}</li>,
                            li2: (text: any) => <li>{text}</li>,
                            li3: (text: any) => <li>{text}</li>,
                        })}
                    </ul>
                </div>
                <NextImage
                    webpSrc={require('@publicLocal/power-ocean/app/2-1.webp')}
                    src={require('@publicLocal/power-ocean/app/2-1.png')}
                    alt={t('sec2_title')}
                    aria-label={t('sec2_title')}
                />
            </div>
            <div className="panel panel-2">
                <div className="left">
                    <SVG2_2 />
                    <p className="title green">{t('sec2_panel2')}</p>
                    <ul>
                        {t.rich('sec2_panel2_list', {
                            li1: (text: any) => <li>{text}</li>,
                            li2: (text: any) => <li>{text}</li>,
                            li3: (text: any) => <li>{text}</li>,
                        })}
                    </ul>
                </div>
                <NextImage
                    webpSrc={require('@publicLocal/power-ocean/app/2-2.webp')}
                    src={require('@publicLocal/power-ocean/app/2-2.png')}
                    alt={t('sec2_title')}
                    aria-label={t('sec2_title')}
                />
            </div>
            <div className="panel">
                <div className="left">
                    <SVG2_3 />
                    <p className="title blue">{t('sec2_panel3')}</p>
                    <ul>
                        {t.rich('sec2_panel3_list', {
                            li1: (text: any) => <li>{text}</li>,
                            li2: (text: any) => <li>{text}</li>,
                            li3: (text: any) => <li>{text}</li>,
                        })}
                    </ul>
                </div>
                <NextImage
                    webpSrc={require('@publicLocal/power-ocean/app/2-3.webp')}
                    src={require('@publicLocal/power-ocean/app/2-3.png')}
                    alt={t('sec2_title')}
                    aria-label={t('sec2_title')}
                />
            </div>
        </div>
    );
}
